<template>
    <div>
        <v-checkbox color="primary-dark" hide-details :label="course.nom" v-model="course.selected"
            @change="$emit('onToggle')" :disabled="!is_selectionnable"
            :class="[!is_selectionnable ? 'line-through' : '']">
        </v-checkbox>
        <RadioSelectionVague v-if="display_vagues_selection" :item="course"></RadioSelectionVague>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import RadioSelectionVague from "./RadioSelectionVague.vue";

export default {
    props: ["item"],
    components: { RadioSelectionVague },
    name: 'CheckboxSelectionParcours',
    data() {
        return {
            // Your component data goes here
        };
    },
    computed: {
        ...mapStores(useMainStore),
        course() {
            return this.item;
        },
        is_selectionnable() {
            const course_selectionable = this.course.is_selectionnable(
                this.mainStore.module.status,
                this.mainStore.view_as_admin,
                this.mainStore.inscription_as_admin,
                this.mainStore.inscription_vip,
                this.mainStore.module.courses,
                this.mainStore.module.is_complet
            );
            return course_selectionable;
        },
        display_vagues_selection() {
            return this.course.vagues.list.length > 0 && this.course.selected;
        }
    },
    methods: {

        // Your component methods go here
    },

};
</script>

<style scoped>
/* Your component styles go here */
</style>